var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtIconsWiFi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5514b4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-2",
    "data-name": "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.4541,13.79736a.49834.49834,0,0,1-.35351-.14648,15.69407,15.69407,0,0,0-22.29,0,.49995.49995,0,0,1-.707-.707,16.69367,16.69367,0,0,1,23.7041,0,.5.5,0,0,1-.35352.85351Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.4502,17.1626a.49839.49839,0,0,1-.35352-.14649,10.1414,10.1414,0,0,0-14.36816,0,.49995.49995,0,1,1-.707-.707,11.141,11.141,0,0,1,15.78223,0,.5.5,0,0,1-.35351.85352Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.37793,20.48584a.5.5,0,0,1-.35352-.85352,5.70532,5.70532,0,0,1,7.93848-.00732.49972.49972,0,1,1-.69141.72168,4.70031,4.70031,0,0,0-6.54-.00732A.49842.49842,0,0,1,12.37793,20.48584Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.90967,22.99607a1.00281,1.00281,0,1,0,1.0028,1.00281.94742.94742,0,0,0-1.0028-1.00281Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtIconsWiFi);
export default __webpack_public_path__ + "static/media/BT_Icons_WiFi.d8587a5252a0e8e24b1bf01cfebff043.svg";
export { ForwardRef as ReactComponent };